<template>
  <v-row>
    <v-col cols="12" md="6" offset-md="3">
      <form @submit.prevent="save">
        <v-text-field
          v-model="form.name"
          label="Ime *"
        ></v-text-field>
        <FormErrors
          v-if="$v.form.$error && (!$v.form.name.required)"
        >
          <FormErrorsLine v-if="!$v.form.name.required" text="Polje je obvezno" />
        </FormErrors>
        <v-btn type="submit" class="float-right">Shrani</v-btn>
        <v-btn text type="button" class="float-right mr-4" @click="$router.go(-1)">Prekliči</v-btn>
      </form>
    </v-col>
  </v-row>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'

export default {
  components: {
    FormErrors,
    FormErrorsLine
  },
  props: {
    taxType: {
      default: () => {},
      type: Object
    }
  },
  data () {
    return {
      form: {
        name: null
      }
    }
  },
  validations: {
    form: {
      name: {
        required
      }
    }
  },
  methods: {
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  created () {
    this.form = { ...this.form, ...this.taxType }
  }
}
</script>
